import { useState } from 'react';
import { IconBolt, IconCalendarTime, IconChartBar, IconPencil } from '@tabler/icons-react/dist/cjs/tabler-icons-react';
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji';
import { getNoun } from '@utils/lib/getNoun';
import { MatchingPreferencesModal } from './matching-preferences-modal';
import s from '../teacher-matching-progress.module.scss';

export const MatchingHeader = ({ profile, isCompleted, levelLabel, startWhenLabel, matchedCount }) => {
	const [isPreferencesOpen, setPreferencesOpen] = useState(false);
	const openPreferences = () => setPreferencesOpen(true);

	return (
		<div className={s.headerCard}>
			<div className={s.headerContent}>
				<div className={s.headerTextRow}>
					<h3 className={s.title}>
						{isCompleted ? (
							<>{matchedCount} {getNoun(matchedCount, 'идеальный наставник', 'идеальных наставника', 'идеальных наставников')}<br/>для тебя</>
						) : (
							<>Подбираем преподавателя<br/>именно для вас</>
						)}
					</h3>
					<p className={s.subtitle}>
						{isCompleted
							? 'Мы тщательно подобрали преподавателей, которые лучше всего подходят под ваши цели и предпочтения.'
							: 'Мы анализируем ваши цели и опыт, чтобы найти идеального преподавателя.'}
					</p>
				</div>
				<div className={s.tags}>
					{profile?.instruments?.length > 0 ? (
						<button type="button" className={s.tag} onClick={openPreferences} aria-label="Изменить параметры подбора">
							<IconBolt className={s.icon}/>
							<span className={s.label}>Инструменты:{' '}</span>
							<span className={s.accent}>
								{profile.instruments.map((instrument, index) => (
									<span key={instrument?.id || instrument?.name}>
										{index > 0 ? ', ' : ''}
										<TextWithEmoji text={instrument?.name} className={s.emoji}/>
									</span>
								))}
							</span>
						</button>
					) : null}
					{startWhenLabel ? (
						<button type="button" className={s.tag} onClick={openPreferences} aria-label="Изменить параметры подбора">
							<IconCalendarTime className={s.icon}/> <span className={s.label}>Время:</span> <span className={s.accent}>{startWhenLabel}</span>
						</button>
					) : null}
					{levelLabel ? (
						<button type="button" className={s.tag} onClick={openPreferences} aria-label="Изменить параметры подбора">
							<IconChartBar className={s.icon}/> <span className={s.label}>Уровень:</span> <span className={s.accent}>{levelLabel}</span>
						</button>
					) : null}
				</div>
			</div>
			{!isCompleted && (
				<div className={s.headerImageWrapper}>
					<img className={s.headerImage} src={process.env.REACT_APP_STORAGE_URL + 'images/mascot/man-search.webp'} alt="" />
				</div>
			)}
			<MatchingPreferencesModal isOpen={isPreferencesOpen} close={() => setPreferencesOpen(false)}/>
		</div>
	);
};
